<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <GnbPmDataQueryLeftTree ref="gnbPmDataQueryLeftTree" @gnbPmDataQueryTreeClickEventPush="gnbPmDataQueryTreeClickEventPush" ></GnbPmDataQueryLeftTree>
    </template>
    <template v-slot:right_view>
      <GnbPmDataQueryRightList ref="gnbPmDataQueryRightList" :treeClickInfo="treeClickInfo"></GnbPmDataQueryRightList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../layouts/BasicLayout';
  import GnbPmDataQueryLeftTree from "../../components/mmlconfig/backup/Left/MMLBackupQueryLeftTree";
  import GnbPmDataQueryRightList from "../../components/mmlconfig/backup/Right/MMLBackupQueryRightList";
  export default {
    name: 'MMLBackup',
    components: {
      BasicLayout,
      GnbPmDataQueryLeftTree,
      GnbPmDataQueryRightList
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('MML.cfgManagement')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: this.$t('MML.cfgNeBackupOrRecover')
        },
        treeClickInfo: {}
      }
    },
    methods: {
      gnbPmDataQueryTreeClickEventPush(params){
        this.treeClickInfo = params;
      }
    }
  };
</script>

<style scoped>
</style>
